export const size = {
  XtraSmall: 'xs',
  Small: 'sm',
  Medium: 'md',
  Large: 'lg',
  XtraLarge: 'xl',
};
